import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { errorsWithParamsMapper } from '../../hooks/utils'
import { EditPaapiSchema } from '../../schemas/editPaapiSchema'
import { toDTO } from './api/mapper'
import { UPDATE_PAAPI_PREBID_MODULE } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdatePaapiPrebidModule } from './types'

export const useUpdatePaapiPrebidModule = (): UseUpdatePaapiPrebidModule => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.modules.general.edit.general.paapi.update',
  })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<EditPaapiSchema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_PAAPI_PREBID_MODULE,
    onCompleted: async (data: Data): Promise<void> => {
      const {
        updatePaapiPrebidModule: { errors, workspacePrebidModule },
      } = data
      if (errors && errors.length > 0) {
        setErrors(errorsWithParamsMapper<EditPaapiSchema>(errors))
        enqueueSnackbar(t('error'), { variant: 'error' })
      } else if (workspacePrebidModule) {
        setErrors({})
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
  })

  const update: UseUpdatePaapiPrebidModule['update'] = data => {
    mutateAsync({
      input: toDTO(data),
    })
  }

  return { errors, update }
}
